(function () {
  "use strict";

  var routes = {
  "college-and-university-match-diplomas-any-country": "assistant-international-diploma",
  "canada-college-university-prop-diploma": "assistant-international-diploma",
  "college-and-university-match-diploma-from-africa": "assistant-international-diploma",
  "uk-college-and-university-match-diplomas": "assistant-international-diploma",
  "college-and-university-match-diploma-from-puerto-rico": "assistant-international-diploma",
  "canada-college-university-match-diploma-and-stock-transcripts": "assistant-international-diploma-stock-transcript",
  "uk-college-university-match-diploma-and-match-transcript-package": "assistant-international-diploma-match-transcript",
  "college-and-university-match-diplomas-from-india": "assistant-international-diploma",
  "college-and-university-match-diploma-from-turkey": "assistant-international-diploma",
  "college-and-university-match-diploma-degree-from-uae": "assistant-international-diploma",
  "college-university-match-diploma-display-copy-france": "assistant-international-diploma",
  "college-university-match-diploma-display-copy-italy": "assistant-international-diploma",
  "college-and-university-match-diploma-from-spain": "assistant-international-diploma",
  "college-and-university-match-diploma-degrees-from-germany": "assistant-international-diploma",
  "college-and-university-match-diplomas-from-malaysia": "assistant-international-diploma",
  "college-and-university-match-diploma-from-argentina": "assistant-international-diploma",
  "college-and-university-match-diplomas-from-singapore": "assistant-international-diploma",
  "college-and-university-match-diploma-from-philippines": "assistant-international-diploma",
  "college-and-university-match-diploma-from-columbia": "assistant-international-diploma",
  "college-and-university-match-diploma-from-brazil": "assistant-international-diploma",
  "college-and-university-match-diploma-from-panama": "assistant-international-diploma",
  "college-and-university-diploma-degrees-in-new-zealand": "assistant-international-diploma",
  "college-and-university-match-diploma-from-albania": "assistant-international-diploma",
  "college-and-university-match-diploma-from-mexico": "assistant-international-diploma",
  "college-university-match-diploma-degree-match-transcripts-africa": "assistant-international-diploma-match-transcript",
  "college-university-match-transcripts-africa": "assistant-international-match-transcript",
  "malaysia-college-university-match-diploma-stock-transcript-package": "assistant-international-diploma-stock-transcript",
  "malaysia-college-university-stock-transcripts": "assistant-international-stock-transcript",
  "malaysia-college-university-match-diplomas": "assistant-international-diploma",
  "australia-college-university-diploma-and-transcript-package": "assistant-international-diploma-stock-transcript",
  "australia-college-university-diploma": "assistant-international-diploma",
  "india-college-university-match-diploma-and-stock-transcript-package": "assistant-international-diploma-stock-transcript",
  "india-college-university-stock-transcripts": "assistant-international-stock-transcript",
  "india-college-university-match-diploma": "assistant-international-diploma",
  "canada-college-university-transcripts": "assistant-international-stock-transcript",
  "uk-college-university-transcript": "assistant-international-stock-transcript",
  "ireland-college-university-match-diploma": "assistant-international-diploma",
  "canada-college-university-match-diploma-and-match-transcripts": "assistant-international-diploma-match-transcript",
  "any-countrys-university-match-transcripts": "assistant-international-match-transcript",
  "canada-college-university-match-transcript": "assistant-international-match-transcript",
  "australia-college-university-transcripts": "assistant-international-stock-transcript",
  "certificate-of-appreciation-thanks-for-college": "assistant-certificate",
  "certificate-of-appreciation-thank-you-for-your-support": "assistant-certificate",
  "bartending-certificates": "assistant-certificate",
  "certificate-of-personal-training": "assistant-certificate",
  "life-coach": "assistant-certificate",
  "certificate-of-authenticity": "assistant-certificate",
  "tafe-certificate-iii-with-transcript-bundle-australia": "assistant-certificate",
  "buy-culinary-certificates": "assistant-certificate",
  "tafe-certificate-iii-transcript-australia": "assistant-certificate",
  "certificate-fetac": "assistant-certificate",
  "certificate-cieh-chartered-instiute-of-environmental-health": "assistant-certificate",
  "certificate-property-manager": "assistant-certificate",
  "certificate-prop-red-seal-canada": "assistant-certificate",
  "buy-certificates-qualifications-global-of-all-kinds": "assistant-certificate",
  "buy-certificates-qualifications-from-uk-of-all-kinds": "assistant-certificate",
  "buy-certificates-and-qualifications-in-usa-of-all-kinds": "assistant-certificate",
  "certificate-gce-general-certificate-of-secondary-education": "assistant-certificate",
  "certificate-of-achievement": "assistant-certificate",
  "certificate-scottish-qualifications-authority": "assistant-certificate",
  "certificate-match-a-certificate-from-your-scan": "assistant-certificate",
  "certificate-cambridge-esol-entry-level": "assistant-certificate",
  "certificate-six-sigma-green-belt": "assistant-certificate",
  "certificate-goalkeeping-coach": "assistant-certificate",
  "certificate-tafe-certificate-iii-australia": "assistant-certificate",
  "certificate-dpsi-diploma-in-public-service-interpreting": "assistant-certificate",
  "certificate-abe-business-executive": "assistant-certificate",
  "certificate-tesol-teaching-english-to-speakers-of-other-languages": "assistant-certificate",
  "certificate-of-personal-training-1": "assistant-certificate",
  "blank-covers": "assistant-hc-cover",
  "diploma-of-graduation-engraved-cover": "assistant-hc-cover",
  "home-school-diploma-engraved-cover": "assistant-hc-cover",
  "home-school-graduate-engraved-cover": "assistant-hc-cover",
  "high-school-diploma-engraved-cover": "assistant-hc-cover",
  "certificate-of-completion-engraved-cover": "assistant-hc-cover",
  "certificate-of-appreciation-engraved-cover": "assistant-hc-cover",
  "college-graduate-engraved-cover": "assistant-hc-cover",
  "thank-you-engraved-cover": "assistant-hc-cover",
  "birth-certificate-engraved-cover": "assistant-hc-cover",
  "certificate-of-marriage-engraved-cover": "assistant-hc-cover",
  "general-education-diploma-engraved-cover": "assistant-hc-cover",
  "high-school-equivalency-engraved-cover": "assistant-hc-cover",
  "custom-logo-and-text-printed-cover": "assistant-hc-cover",
  "add-hard-copy-version-if-you-originally-only-ordered-email-only-version": "assistant-hc-upgrade",
  "add-email-version-if-you-originally-ordered-only-hard-copy": "assistant-hc-upgrade",
  "upgrade-to-match-diploma-from-stock-college-or-university": "assistant-hc-upgrade",
  "shipping-upgrade-to-ups-ground": "assistant-hc-upgrade",
  "email-delivery-rush-charge": "assistant-hc-upgrade",
  "reprint-of-college-diploma-or-transcripts": "assistant-hc-reprint",
  "reprint-of-lower-school-diploma-or-transcripts": "assistant-hc-reprint",
  "reprint-of-college-diploma-or-transcripts-with-changes": "assistant-hc-reprint",
  "reprint-of-lower-school-diploma-or-transcripts-with-changes": "assistant-hc-reprint",
  "state-seals-metallic-gold": "assistant-hc-seal",
  "i-want-to-submit-a-design-to-be-made": "assistant-hc-design",
  "custom-quote-document": "assistant-hc-design",
  "gracieone-studio-custom-certificates": "assistant-certificate"
};

  var collectionRoutes = {
    "accessories": "hc-accessories",
    "accessories-collection": "hc-accessories-collection",
    "africa-college-university-diplomas-transcripts": "hc-africa-college-university-diplomas-transcripts",
    "australia-college-university-diplomas-transcripts": "hc-australia-college-university-diplomas-transcripts",
    "high-school-equivalency": "hc-high-school-equivalency",
    "canada-college-university-diplomas-transcripts": "hc-canada-college-university-diplomas-transcripts",
    "certificate-maker": "hc-certificate-maker",
    "college-university-transcripts": "hc-college-university-transcripts",
    "replacement-diploma-transcript-maker": "hc-replacement-diploma-transcript-maker",
    "custom-covers": "hc-custom-covers",
    "diploma-maker": "hc-diploma-maker",
    "diploma-covers": "hc-diploma-covers",
    "france-college-university-diplomas-transcripts": "hc-france-college-university-diplomas-transcripts",
    "germany-college-university-diplomas-transcripts": "hc-germany-college-university-diplomas-transcripts",
    "high-school-diploma-transcript-maker": "hc-high-school-diploma-transcript-maker",
    "homeschool": "hc-homeschool",
    "homeschool-diplomas": "hc-homeschool-diplomas",
    "india-college-university-diplomas-transcripts": "hc-india-college-university-diplomas-transcripts",
    "international-diplomas-transcripts": "hc-international-diplomas-transcripts",
    "ireland-college-university-diplomas-and-transcripts": "hc-ireland-college-university-diplomas-and-transcripts",
    "italy-college-university-diplomas-transcripts": "hc-italy-college-university-diplomas-transcripts",
    "malaysia-college-university-transcripts-and-diplomas": "hc-malaysia-college-university-transcripts-and-diplomas",
    "mexico-college-university-diplomas-transcripts": "hc-mexico-college-university-diplomas-transcripts",
    "other-country-college-university-diplomas-transcripts": "hc-other-country-college-university-diplomas-tra-9epfqp",
    "philippines-college-university-diplomas-transcripts": "hc-philippines-college-university-diplomas-transcripts",
    "prop-novelty-covers": "hc-prop-novelty-covers",
    "puerto-rico-college-university-diplomas-transcripts": "hc-puerto-rico-college-university-diplomas-transcripts",
    "reprints": "hc-reprints",
    "seals-and-emblems": "hc-seals-and-emblems",
    "transcript-maker": "hc-transcript-maker",
    "uk-college-university-diplomas-transcripts": "hc-uk-college-university-diplomas-transcripts"
  };

  function productHandleFromPath(pathname) {
    var match = pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function collectionHandleFromPath(pathname) {
    if (/\/products\//.test(pathname)) return "";
    var match = pathname.match(/\/collections\/([^/?#]+)\/?$/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function addViewToUrl(rawUrl, suffix) {
    var url = new URL(rawUrl, window.location.origin);
    if (url.origin !== window.location.origin) return rawUrl;
    url.searchParams.set("view", suffix);
    return url.pathname + url.search + url.hash;
  }

  function rewriteProductLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }
      if (url.origin !== window.location.origin) return;
      var handle = productHandleFromPath(url.pathname);
      var suffix = routes[handle];
      if (!suffix || url.searchParams.get("view") === suffix) return;
      link.setAttribute("href", addViewToUrl(url.href, suffix));
    });
  }

  function rewriteCollectionLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('a[href*="/collections/"]').forEach(function (link) {
      var url;
      try { url = new URL(link.href, window.location.origin); } catch (error) { return; }
      if (url.origin !== window.location.origin) return;
      var suffix = collectionRoutes[collectionHandleFromPath(url.pathname)];
      if (!suffix || url.searchParams.get("view") === suffix) return;
      link.setAttribute("href", addViewToUrl(url.href, suffix));
    });
  }

  function routeCurrentCollection() {
    var suffix = collectionRoutes[collectionHandleFromPath(window.location.pathname)];
    if (!suffix) return false;
    var current = new URL(window.location.href);
    if (current.searchParams.get("view") === suffix) return false;
    current.searchParams.set("view", suffix);
    window.location.replace(current.pathname + current.search + current.hash);
    return true;
  }

  function routeCurrentProduct() {
    var handle = productHandleFromPath(window.location.pathname);
    var suffix = routes[handle];
    if (!suffix) return false;

    var current = new URL(window.location.href);
    if (current.searchParams.get("view") === suffix) return false;

    current.searchParams.set("view", suffix);
    window.location.replace(current.pathname + current.search + current.hash);
    return true;
  }

  if (routeCurrentProduct()) return;

  rewriteProductLinks(document);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          rewriteProductLinks(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
